import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import parse from "html-react-parser"
import Arrow from "@assets/icons/arrow.inline.svg"

import { Link } from "@components/common/link/Link"

import * as s from "./SupportHeaderTabs.module.scss"

export const SupportHeaderTabs = () => {
  const { allWpPage } = useStaticQuery(graphql`
    query SupportTabsQuery {
      allWpPage(filter: { template: { templateName: { eq: "Support" } } }) {
        nodes {
          title
          uri
        }
      }
    }
  `)

  const tabs = allWpPage.nodes
  const [pathname, setPathname] = useState("")

  const [menuOpen, setMenuOpen] = useState(false)
  const handleOpenMenu = () => {
    setMenuOpen(prev => {
      return !prev
    })
  }

  useEffect(() => {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : ""
    setPathname(pathname)
  }, [])

  return (
    <div className={s.Wrapper}>
      <div className={`${menuOpen ? s.Inner__openMenu : ""} ${s.Inner}`}>
        {tabs.map((tab, i) => {
          return (
            <Link
              key={i}
              to={tab.uri}
              onClick={() => handleOpenMenu()}
              className={`${s.tab} 
                    ${pathname === tab.uri && s.tab___active}
                    ${pathname === tab.uri && s.tab___active}`}
            >
              <span>{parse(tab.title)}</span>

              <span className={s.SupportHeader__button}>
                <Arrow className={s.SupportHeader__arrow} />
              </span>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
